import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ISearchResponse } from '@models/scraperModel/searchModel';
import { ISimilarResponse } from '@models/scraperModel/similarModel';
import { axiosInstance, axiosScraper, axiosDummyInstance } from '@utils/axios/axiosInstance';
import { getHttpResponseResult } from '@utils/axios/httpResponseHelper';
import { LayoutDTO } from '@models/layout/layoutModel';

/**
 * [GET] 나의 앱 리스트 조회
 */
export const getMyAppsThunk = createAsyncThunk('getMyAppsThunk', async (params, { rejectWithValue }) => {
  try {
    // // 아래부분은 연결부분 주석처리함.
    // const response = await axiosInstance.get(`/app/my`);
    const response = await axiosDummyInstance.get('/api/app/registeredMyAppList.json');
    const { success, data } = getHttpResponseResult<LayoutDTO.MyApp[]>(response);
    if (success) {
      return data;
    } else {
      return rejectWithValue(data);
    }
  } catch (error) {
    return rejectWithValue(error);
  }
});

/**
 * [GET] 앱 상세 정보 조회
 * DEPRECATED
 */
export const getAppInfoDetailThunk = createAsyncThunk(
  'getAppInfoDetailThunk',
  async (appSeq: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/detail', { params: { appSeq } });
      const { success, data } = getHttpResponseResult<LayoutDTO.MyApp | null>(response, 'result');
      if (success) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {}
  }
);

/**
 * [GET] 경쟁자 앱 리스트 요청
 * TODO: reponse로 받는 competitorApps 타입 추후 변경처리하기
 */
export const getComptitorAppsThunk = createAsyncThunk(
  'getComptitorAppsThunk',
  async (appSeq: number, { rejectWithValue }) => {
    try {
      // // 아래가 연결부분
      // const response = await axiosInstance.get('/app/competitor', { params: { appSeq } });
      const response = await axiosDummyInstance.get('/api/competitorsApp.json');
      const { success, data } = getHttpResponseResult<LayoutDTO.MyApp[]>(response);
      if (success) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * [PUT] 경쟁자 앱 추가앱리스트, 삭제앱리스트 보내기
 * TODO: reponse로 받는 competitorApps 타입 추후 변경처리하기
 */
type reqPUTCompetitorAppsParams = {
  appSeq: number;
  providerType: string;
  addCompetitorApps: LayoutDTO.MyApp[];
  deleteCompetitorApps: LayoutDTO.MyApp[];
};
export const putCompetitorAppsThunk = createAsyncThunk(
  'putCompetitorAppsThunk',
  async (
    { appSeq, providerType, addCompetitorApps, deleteCompetitorApps }: reqPUTCompetitorAppsParams,
    { rejectWithValue }
  ) => {
    try {
      // // 아래껀 기존의 요청
      // const response = await axiosInstance.post('/app/competitor', {
      //   appSeq,
      //   providerType,
      //   addCompetitorApps,
      //   deleteCompetitorApps,
      // });
      const response = await axiosDummyInstance.get(
        ['/api/competitorsApp2.json', '/api/competitorsApp2.json'][Math.floor(Math.random() * 1)],
        {}
      );
      const { success, data } = getHttpResponseResult<{ result: boolean; message: string }>(response);
      if (success) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * [DELETE] 내앱
 */
export type reqDeleteMyCompetitorAppType = {
  myAppSeq: string | number;
  competitorAppId: string;
  comprtitorProviderType: string;
};
export const deleteSingleCompetitorApp = createAsyncThunk(
  'deleteSingleCompetitorApp',
  async (params: reqDeleteMyCompetitorAppType, { rejectWithValue }) => {
    try {
      // // 아래는 기존의 요청
      // const response = await axiosInstance.delete('/app/competitor', {
      //   data: {
      //     appSeq: params?.myAppSeq,
      //     appId: params?.competitorAppId,
      //     providerType: params?.comprtitorProviderType,
      //   },
      // });
      const response = await axiosDummyInstance.get('/api/commonGetResponse.json');
      const { success, data } = getHttpResponseResult<{ result: boolean; message: string }>(response);
      if (success) {
        return params;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type reqFetchSelectedAppInfoType = {
  provider_type: string;
  appId: string;
  lang: string;
  country: string;
};

/**
 * [GET] 헤더에서 검색한 앱정보
 */
export const getHeaderSearchedAppInfo = createAsyncThunk(
  'getSearchedAppInfo',
  async (params: reqFetchSelectedAppInfoType, { rejectWithValue }) => {
    try {
      const { provider_type, appId, lang, country } = params;
      const response = await axiosScraper.post(`/${provider_type}/app`, {
        appId: appId,
        country: country,
        lang: lang,
      });
      const { success, data } = getHttpResponseResult<ISearchResponse>(response);
      if (success) {
        return { ...data, providerType: data.provider_type };
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// selectedApp 을 선택 시 similarApps 리스트 가져오기
/**
 * [GET] 헤더에서 검색한 앱정보 선택 시 myApp 으로 등록이 안되어있으면 유사앱 리스트 요청
 */
export const getSimilarAppsList = createAsyncThunk(
  'getSimilarAppsList',
  async (params: { appId: string; provider_type: string }, { rejectWithValue }) => {
    try {
      const response = await axiosScraper.post(`/${params?.provider_type}/similar`, {
        appId: params?.appId,
      });
      const { success, data } = getHttpResponseResult<ISimilarResponse>(response);
      if (success) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
